import { Component, Input, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { NewPackagesComponent } from './new-packages/new-packages.component';
import { EditPackageComponent } from './edit-package/edit-package.component';
import { ImagePackageComponent } from './image-package/image-package.component';
import { environment } from '../../../../../environments/environment';
import { FloorplanPackageComponent } from './floorplan-package/floorplan-package.component';
import { PropertyPackageComponent } from './property-package/property-package.component';
import { DeleteDialogComponent } from '../delete-dialog/delete-dialog.component';
import { LinkLotComponent } from './link-lot/link-lot.component';

import { HttpService } from '../../../../core';
@Component({
    selector: 'app-packages',
    templateUrl: './packages.component.html',
    styleUrls: ['./packages.component.scss']
})

export class PackagesComponent implements OnInit {
    @Input() project: any;
    SERVER_URL = environment.SERVER_URL;

    constructor(private dialog: MatDialog, private httpService: HttpService,) {
    }

    ngOnInit(): void {
        this.httpService.getProjectDetailByProjectId(this.project.id).toPromise().then((projectDetail: any) => {
            this.project = projectDetail.data
        })
    }

    openNewPackage() {
        const dialogRef = this.dialog.open(NewPackagesComponent, {
            width: '80%',
            data: {
                projectId: this.project.id
            }
        });

        dialogRef.afterClosed().subscribe((result: any) => {
            if (result && result.package) {
                if (this.project.packageProjects) {
                    this.project.packageProjects.push(result.package);
                } else {
                    this.project.packageProjects = [result.package];
                }
            }
        });

    }

    openEditPackage(packageProject) {
        console.log(packageProject);
        const dialogRef = this.dialog.open(EditPackageComponent, {
            width: '90%',
            maxWidth: '1400px',
            height: '600px',
            data: {
                packageProject
            }
        });

        dialogRef.afterClosed().subscribe((result: any) => {
            if (result) {
                this.project.packageProjects = this.project.packageProjects.filter(pp => pp.id !== result.result.id);
                this.project.packageProjects.push(result.result);
            }
        });
    }

    openImagePackage(packageProject) {
        const dialogRef = this.dialog.open(ImagePackageComponent, {
            width: '80%',
            // height: '80%',
            data: {
                packageProject,
                project: this.project
            }
        });
    }

    openFloorplanPackage(packageProject) {
        const dialogRef = this.dialog.open(FloorplanPackageComponent, {
            width: '80%',
            data: {
                packageProject,
                project: this.project

            }
        });
    }

    openPropertyPackage(packageProject) {
        const dialogRef = this.dialog.open(PropertyPackageComponent, {
            width: '90%',
            maxWidth: '1400px',
            data: {
                packageProject,
                project: this.project
            }
        });
    }

    openLinkLot(packageProject) {
        const dialogRef = this.dialog.open(LinkLotComponent, {
            width: '80%',
            data: {
                packageProject,
                project: this.project
            }
        });
    }

    openDeletePackage(packageProject) {
        const dialogRef = this.dialog.open(DeleteDialogComponent, {
            width: '400px',
            data: {
                isPackage: true,
                packageProject,
                parentProjectId: this.project.id
            }
        });

        dialogRef.afterClosed().subscribe((result: any) => {
            if (result) {
                this.ngOnInit();
            }
        });
    }
}
